import { RefSelectProps, Select, SelectProps, Typography } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import { forwardRef, ForwardRefRenderFunction } from 'react';
import { useTranslation } from 'react-i18next';
import { useGetClientUsersQuery } from '../../api/client-users-api';

type Props = Omit<SelectProps, 'filterOption' | 'showSearch' | 'onSearch' | 'onBlur'>;

const ClientUsersSelect: ForwardRefRenderFunction<RefSelectProps, Props> = (props, ref) => {
  const { data: clientUsers } = useGetClientUsersQuery({
    page: 1,
    limit: 9999,
    name: '',
    unit: '',
    surname: '',
    phone: '',
    email: '',
    group: '',
    roles: '',
    username: '',
  });
  const { t } = useTranslation('common');

  const filterClientUsers = (inputValue: string, option: DefaultOptionType | undefined) => {
    if (typeof option?.value === 'string') {
      const clientUser = clientUsers?.items.find(user => user.id === option?.value);
      return (
        clientUser?.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        clientUser?.username.toLowerCase().includes(inputValue.toLowerCase()) ||
        false
      );
    }
    return false;
  };

  return (
    <Select
      ref={ref}
      filterOption={filterClientUsers}
      showSearch
      allowClear={true}
      placeholder={t('placeholder.userSearch')}
      {...props}
    >
      {clientUsers?.items.map(({ id, name, username }) => (
        <Select.Option key={id} value={id}>
          {name} – <Typography.Text italic>{username}</Typography.Text>
        </Select.Option>
      ))}
    </Select>
  );
};

export default forwardRef(ClientUsersSelect);
